import { Box } from "flicket-ui";
import { ReactNode, useState } from "react";
import { useIntersectionObserver } from "usehooks-ts";

export type IStickySection = {
  children: ReactNode | ((props: { isSticky: boolean }) => ReactNode);
  options?: ArgumentTypes;
  offset?: number;
};

type ArgumentTypes = Parameters<typeof useIntersectionObserver>[1];

export default function StickySection({
  children,
  options = {},
  offset = 0,
}: IStickySection) {
  const [isSticky, setIsSticky] = useState(false);

  const { ref } = useIntersectionObserver({
    threshold: 1,
    // rootMargin: `-2px 0px 0px 0px`,
    ...options,
    onChange(isIntersecting, entry) {
      const isInteresectingWithTop =
        entry.boundingClientRect.top < entry.intersectionRect?.top;

      setIsSticky(isInteresectingWithTop);
    },
  });

  if (!children) return null;

  return (
    <>
      <Box
        ref={ref}
        css={`
          /* https://stackoverflow.com/questions/16302483/event-to-detect-when-positionsticky-is-triggered */
          position: sticky;
          top: ${offset - 1}px;
          padding-top: ${offset + 1}px;
          z-index: 99;
        `}
      >
        {typeof children === "function" ? children({ isSticky }) : children}
      </Box>
    </>
  );
}
